import { render, staticRenderFns } from "./AlertBoxTemplate.vue?vue&type=template&id=031854e6&scoped=true"
import script from "./AlertBoxTemplate.vue.ts?vue&type=script&lang=ts&external"
export * from "./AlertBoxTemplate.vue.ts?vue&type=script&lang=ts&external"
import style0 from "./AlertBoxTemplate.vue?vue&type=style&index=0&id=031854e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031854e6",
  null
  
)

export default component.exports